var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Cookie from "js-cookie";
import once from "lodash-es/once";
import { initBedrock, parseAccessTokenJwt, requireAccessToken } from "@nbcnews/bedrock-web-sdk";
const ACCESS_TOKEN_COOKIE = "access_token";
/**
 * Initializes the bedrock SDK against the production environment exactly once,
 * no matter how many times it is invoked.
 */
const ensureBedrockInitialized = once(() => initBedrock({ environment: "prod" }));
/**
 * Higher-order function that guarantees the bedrock SDK is initialized before
 * the wrapped auth function runs.
 */
const withBedrock = (fn) => (...args) => {
    ensureBedrockInitialized();
    return fn(...args);
};
/**
 * Synchronous, side-effect-free auth check. Decodes the `access_token` cookie
 * and verifies it is present and not expired. Safe to call frequently (e.g. on
 * window focus) because it performs no network request and never mutates cookies.
 */
export const isAuthenticated = withBedrock(() => {
    var _a;
    const accessToken = Cookie.get(ACCESS_TOKEN_COOKIE);
    if (!accessToken || !((_a = window.uscWidget.config.accounts) === null || _a === void 0 ? void 0 : _a.enabled)) {
        return false;
    }
    const parsed = parseAccessTokenJwt(accessToken);
    return !!parsed && parsed.exp * 1000 > Date.now();
});
/**
 * Returns the current user id from the `sub` claim of the access token.
 */
export const getUserId = withBedrock(() => {
    const accessToken = Cookie.get(ACCESS_TOKEN_COOKIE);
    const parsed = accessToken ? parseAccessTokenJwt(accessToken) : undefined;
    return parsed === null || parsed === void 0 ? void 0 : parsed.sub;
});
/**
 * Ensures a valid (non-expired) access token, refreshing it via the bedrock SDK
 * if necessary, and returns the raw JWT for use as an `Access-token` header.
 * Returns null if the user is not authenticated or the token could not be
 * refreshed. Must only be called immediately before an authenticated request,
 * as a failed refresh signs the user out (clears auth cookies).
 */
export const ensureFreshAccessToken = withBedrock(() => __awaiter(void 0, void 0, void 0, function* () {
    const cookieData = yield requireAccessToken({
        scope: "read_write"
    });
    return (cookieData === null || cookieData === void 0 ? void 0 : cookieData.raw) || null;
}));
